export default __webpack_public_path__ + "static/media/arrow_down.d36fdef8.svg";